'use client';

import BranchCard from '@/components/branch-card';
import Pagination from '@/components/pagination';
import { StoreEntity } from '@/services/types/store.type';

interface Props {
  branches: StoreEntity[];
  pageSize?: number;
  totalCount?: number;
  page: number;
  onPageChange: (page: number) => void;
}

const BranchGrid = ({
  branches,
  pageSize = 9,
  totalCount = 0,
  page,
  onPageChange,
}: Props) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalCount == 0) {
    return (
      <div className="pt-15 pb-40">
        <div className="text-level-6 typo-16 text-center font-semibold">
          지점 데이터가 없습니다.
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="desktop:grid-cols-3 desktop:gap-x-7.5 desktop:gap-y-15 grid w-full grid-cols-1 gap-y-8">
        {branches.map((branch) => (
          <BranchCard {...branch} key={branch.id} />
        ))}
      </div>
      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default BranchGrid;
